import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cuttlefish': {
    width: 440,
    height: 512,
    paths: [
      {
        d: 'M344 305.5c13.7 50.9 41.7 93.3 87 117.8-45.3 49.6-110.5 80.7-183 80.7-137 0-248-111-248-248s111-248 248-248c72.5 0 137.7 31.1 183 80.7-45.3 24.5-73.3 66.9-87 117.8-17.5-31.6-57.4-54.5-96-54.5-56.6 0-104 47.4-104 104s47.4 104 104 104c38.6 0 78.5-22.9 96-54.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/cuttlefish.js
// module id = 624
// module chunks = 0